import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { FDSecondaryActionIconButton } from '@facet-wealth/design';

const QuickEditButton = ({
  resource,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { loadModalCollectionByLink } = useModalContext();

  const handleOnClick = (e) => {
    e.stopPropagation();
    loadModalCollectionByLink(resource.relationship(fr.relationships.outcomeQuickEdit.name).link('related').url());
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'quick edit outcome');
  };

  return (
    <FDSecondaryActionIconButton
      icon="edit"
      label="Quick Edit Outcome"
      onClick={(e) => handleOnClick(e)}
    />
  );
};

QuickEditButton.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default QuickEditButton;
